/* ============================================================
   LAO — Diagnostic cheveux (V2) — moteur client déterministe
   Textes = metaobjects (window.LAO_DIAG_TEXT) ; logique + produits = ici.
   ============================================================ */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0396/2680/1301/files/';
  var P = {
    purifiant:   { id: 48428022006104, name: 'Shampoing Purifiant',          url: '/products/shampoing-purifiant',            img: CDN+'Shampoing-Purifiant-LAO-Care-218016058_600x.png' },
    nourrissant: { id: 48427544478040, name: 'Shampoing Nourrissant',        url: '/products/shampoing-nourrissant',          img: CDN+'Shampoing-Nourrissant-LAO-Care-218016776_600x.png' },
    apres:       { id: 49958308675928, name: 'Après-Shampoing Démêlant',     url: '/products/apres-shampoing',                img: CDN+'Apres-Shampoing-Demelant-LAO-Care-218061888_600x.png' },
    regenerant:  { id: 50015558500696, name: 'Shampoing Régénérant',         url: '/products/shampoing-regenerant',           img: CDN+'Principaleshampoingregenerant_600x.png' },
    masque:      { id: 50015579373912, name: 'Masque Régénérant',            url: '/products/masque-regenerant',              img: CDN+'Principalemasqueregenerant_600x.png' },
    creme:       { id: 50015589138776, name: 'Crème Capillaire Régénérante', url: '/products/creme-capillaire-regenerante',   img: CDN+'Principale-creme-capillaire-regenerante_600x.png' },
    silicone:    { id: 57335253565784, name: 'Silicone Détox',               url: '/products/silicone-detox',                 img: CDN+'sitox_principale_600x.png' },
    gelee:       { id: 56890578141528, name: 'Gelée Boucles Légères',        url: '/products/gelee-boucles-legeres',          img: CDN+'Gelee-Boucles-Legeres-LAO-Care-217962989_600x.jpg' },
    huile:       { id: 58498740978008, name: 'Huile Brillance',              url: '/products/huile-brillance',               img: CDN+'Huile_principale_676564de-1816-4ef2-99e0-41a384626006_600x.png' }
  };
  var TEXT = window.LAO_DIAG_TEXT || {};

  class DiagnosticBuilder extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-diag-form]');
      this.screens = Array.from(this.querySelectorAll('.diag__screen'));
      this.nav = this.querySelector('[data-diag-nav]');
      this.prevBtn = this.querySelector('[data-diag-prev]');
      this.nextBtn = this.querySelector('[data-diag-next]');
      this.progress = this.querySelector('[data-diag-progress]');
      this.bar = this.querySelector('[data-diag-bar]');
      this.stepEl = this.querySelector('[data-diag-step]');
      this.totalEl = this.querySelector('[data-diag-total]');
      this.answers = {};
      this.profile = {};
      this.order = [];
      this.pos = 0;
      this.removed = {};
      this.promoCode = this.dataset.promo || '';
      this.bind();
      this.buildOrder();
      this.show(0);
    }

    bind() {
      var self = this;
      this.querySelectorAll('[data-diag-gender] .diag__pill').forEach(function (b) {
        b.addEventListener('click', function () {
          self.querySelectorAll('[data-diag-gender] .diag__pill').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active'); self.profile.gender = b.dataset.value;
        });
      });
      var start = this.querySelector('[data-diag-start]');
      if (start) start.addEventListener('click', function () {
        var fn = self.querySelector('[data-diag-firstname]');
        if (!fn.value.trim()) { fn.focus(); return; }
        self.profile.firstname = fn.value.trim();
        self.profile.age = (self.querySelector('[data-diag-age]') || {}).value || '';
        self.next();
      });
      this.querySelectorAll('[data-diag-option]').forEach(function (card) {
        card.addEventListener('click', function () {
          var qkey = card.dataset.qkey, val = card.dataset.value, screen = card.closest('.diag__screen');
          var multi = screen.dataset.multi === 'true';
          if (multi) {
            self.answers[qkey] = self.answers[qkey] || [];
            var i = self.answers[qkey].indexOf(val);
            if (i >= 0) { self.answers[qkey].splice(i, 1); card.classList.remove('is-selected'); }
            else { self.answers[qkey].push(val); card.classList.add('is-selected'); }
          } else {
            screen.querySelectorAll('.diag__card').forEach(function (c) { c.classList.remove('is-selected'); });
            card.classList.add('is-selected'); self.answers[qkey] = val;
            setTimeout(function () { self.next(); }, 220);
          }
          self.refreshNext();
        });
      });
      this.nextBtn.addEventListener('click', function () { self.next(); });
      this.prevBtn.addEventListener('click', function () { self.prev(); });
      var submit = this.querySelector('[data-diag-submit]');
      if (submit) submit.addEventListener('click', function () { self.submitEmail(); });
      this.addEventListener('click', function (e) { if (e.target.closest('[data-diag-add-cart]')) self.addToCart(); });
      this.addEventListener('click', function (e) { var ab = e.target.closest('[data-diag-acc-add]'); if (ab) self.addAccessory(ab); });
      this.addEventListener('change', function (e) { var sv = e.target.closest('[data-diag-acc-variant]'); if (sv) self.syncAccItem(sv.closest('.diag__acc__item')); });
      var restart = this.querySelector('[data-diag-restart]');
      if (restart) restart.addEventListener('click', function () { location.reload(); });
    }

    buildOrder() {
      var self = this; this.order = [];
      this.screens.forEach(function (s, idx) {
        if (s.dataset.screen === 'question') {
          var cond = s.dataset.showIfTexture;
          if (cond) {
            var allowed = cond.split(',').map(function (x) { return x.trim().toLowerCase(); });
            if (allowed.indexOf((self.answers.texture || '').toLowerCase()) === -1) return;
          }
        }
        self.order.push(idx);
      });
    }

    show(pos) {
      this.buildOrder();
      if (pos < 0) pos = 0; if (pos >= this.order.length) pos = this.order.length - 1;
      this.pos = pos;
      var activeIdx = this.order[pos];
      this.screens.forEach(function (s, i) { s.classList.toggle('is-active', i === activeIdx); });
      var kind = this.screens[activeIdx].dataset.screen, isQ = kind === 'question';
      this.nav.hidden = !isQ;
      this.progress.hidden = !(isQ || kind === 'email');
      this.prevBtn.style.visibility = pos <= 1 ? 'hidden' : 'visible';
      this.updateGauge(); this.refreshNext(); this.scrollTop();
    }

    updateGauge() {
      var self = this;
      var total = this.order.filter(function (idx) { return ['question', 'email'].indexOf(self.screens[idx].dataset.screen) >= 0; }).length;
      var done = this.order.slice(0, this.pos + 1).filter(function (idx) { return ['question', 'email'].indexOf(self.screens[idx].dataset.screen) >= 0; }).length;
      var pct = total ? Math.round(done / total * 100) : 0;
      if (this.bar) this.bar.style.width = pct + '%';
      if (this.stepEl) this.stepEl.textContent = done;
      if (this.totalEl) this.totalEl.textContent = total;
    }

    refreshNext() {
      var screen = this.screens[this.order[this.pos]];
      if (!screen || screen.dataset.screen !== 'question') return;
      var a = this.answers[screen.dataset.qkey];
      this.nextBtn.disabled = !(Array.isArray(a) ? a.length > 0 : !!a);
    }
    next() { if (this.pos < this.order.length - 1) this.show(this.pos + 1); }
    prev() { if (this.pos > 0) this.show(this.pos - 1); }

    // ===== Lecture profil =====
    isThick() { var e = (this.answers.epaisseur || '').toLowerCase(); return e.indexOf('épais') >= 0 || e.indexOf('epais') >= 0; }
    isFine() { return (this.answers.epaisseur || '').toLowerCase().indexOf('fin') >= 0; }
    texture() { return (this.answers.texture || '').toLowerCase(); }
    isCurly() { var t = this.texture(); return t.indexOf('boucl') >= 0 || t.indexOf('fris') >= 0 || t.indexOf('crép') >= 0 || t.indexOf('crep') >= 0; }
    isCoily() { var t = this.texture(); return t.indexOf('crép') >= 0 || t.indexOf('crep') >= 0; }
    textureWord() { var t = (this.answers.texture || '').toLowerCase(); if (t.indexOf('fris') >= 0) return 'frisés'; if (t.indexOf('crép') >= 0 || t.indexOf('crep') >= 0) return 'crépus'; if (t.indexOf('boucl') >= 0) return 'bouclés'; if (t.indexOf('ondul') >= 0) return 'ondulés'; return 'bouclés'; }

    // ===== Helpers texte / produit =====
    isNourrissant() { var c = this.answers.cuir || ''; return this.isThick() && ['cuir_sensible', 'pellicules_seches', 'cuir_sain'].indexOf(c) >= 0; }
    shampoo() { return this.isNourrissant() ? 'Shampoing Nourrissant' : 'Shampoing Purifiant'; }
    routineName() { var c = this.isCurly(), n = this.isNourrissant(); return c ? (n ? 'Routine Douceur Boucles' : 'Routine Légèreté Boucles') : (n ? 'Routine Douceur' : 'Routine Légèreté'); }
    needsSilicone() {
      var sil = this.answers.silicone, volume = this.answers.coiffant === 'volume_xxl';
      if (sil === 'non') return false;
      if (this.isCoily()) return false;
      return sil === 'oui' || sil === 'je_sais_pas' || volume || this.isFine();
    }
    fill(t) {
      if (!t) return '';
      var apres = this.answers.demelage === 'demelage_oui' ? " Complétez avec l'Après-Shampoing pour faciliter le démêlage et apporter de la douceur aux longueurs." : '';
      t = t.replace(/\{shampoing\}/g, this.shampoo()).replace(/\{routine\}/g, this.routineName()).replace(/\{apres\}/g, apres);
      t = t.replace(/\{cure_coiffage\}/g, (this.isCurly() && TEXT['cure_coiffage']) ? TEXT['cure_coiffage'].reco : '');
      t = t.replace(/\{creme_coiffage\}/g, (this.isCurly() && this.isThick() && TEXT['creme_coiffage']) ? TEXT['creme_coiffage'].reco : '');
      t = t.replace(/\{texture\}/g, this.textureWord());
      return t;
    }
    para(t) { return (t || '').split(/\n\n+/).map(function (p) { return '<p>' + p.replace(/\n/g, '<br>').replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>') + '</p>'; }).join(''); }
    // Texte -> HTML pour le mail (échappe, puis gras **..** + retours ligne)
    richText(t) { return (t || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>'); }

    // ===== Reco =====
    computeRoutine() {
      // Produits UNITAIRES (comme la routine sur-mesure) -> descriptions/actifs auto-corrects
      var items = [], curl = this.isCurly(), n = this.isNourrissant();
      // Lavant quotidien (toujours)
      items.push({ key: n ? 'nourrissant' : 'purifiant', role: 'Shampoing quotidien' });
      // Après-shampoing si la personne a besoin d'aide au démêlage
      if (this.answers.demelage !== 'demelage_non') items.push({ key: 'apres', role: 'Après-shampoing' });
      // Cure régénérante (protocole 3 étapes) si longueurs abîmées / casse
      if (['reparer_abimes', 'moins_de_casse'].indexOf(this.answers.longueur) >= 0) {
        items.push({ key: 'regenerant', role: 'Cure · shampoing régénérant' });
        items.push({ key: 'masque', role: 'Cure · masque régénérant' });
        items.push({ key: 'creme', role: 'Cure · crème sans rinçage' });
      }
      // Étape 0 — Silicone Détox
      if (this.needsSilicone()) items.push({ key: 'silicone', role: 'Étape 0 — Silicone Détox' });
      // Coiffage boucles
      if (curl || this.answers.coiffant === 'boucles_definies') items.push({ key: 'gelee', role: 'Coiffant boucles' });
      // Finition brillance
      if (this.answers.coiffant === 'brillance_douceur' || this.answers.longueur === 'doux_brillants') items.push({ key: 'huile', role: 'Finition brillance' });
      var seen = {}, out = items.filter(function (it) { if (seen[it.key]) return false; seen[it.key] = 1; return true; });
      // Badges "Essentiel" : shampoing quotidien (toujours), gelée (boucles), masque + crème (abîmés), silicone si lourds/saturés
      var lourds = this.answers.silicone === 'oui';
      out.forEach(function (it) {
        it.essential = (it.key === 'purifiant' || it.key === 'nourrissant' || it.key === 'gelee' || it.key === 'masque' || it.key === 'creme' || (it.key === 'silicone' && lourds));
      });
      // Max 4 badges (priorité : shampoing > masque > crème > gelée > silicone)
      var prio = ['purifiant', 'nourrissant', 'masque', 'creme', 'gelee', 'silicone'];
      var ess = out.filter(function (it) { return it.essential; });
      if (ess.length > 4) { ess.sort(function (a, b) { return prio.indexOf(a.key) - prio.indexOf(b.key); }); ess.slice(4).forEach(function (it) { it.essential = false; }); }
      return out;
    }
    discountFor(n) { return n >= 5 ? 15 : n >= 4 ? 12 : n >= 3 ? 8 : 0; }

    submitEmail() {
      var email = (this.querySelector('[data-diag-email]') || {}).value || '', consent = this.querySelector('[data-diag-consent]');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { this.querySelector('[data-diag-email]').focus(); return; }
      if (consent && !consent.checked) { consent.focus(); return; }
      this.profile.email = email; this.profile.consent = true;
      var phoneNum = ((this.querySelector('[data-diag-phone]') || {}).value || '').trim();
      var indic = ((this.querySelector('[data-diag-indicatif]') || {}).value || '').trim();
      this.profile.phone = phoneNum ? ((indic ? indic + ' ' : '') + phoneNum) : '';
      var phoneDigits = phoneNum.replace(/\D/g, '').replace(/^0+/, '');
      this.profile.phoneE164 = (phoneNum && indic) ? (indic + phoneDigits) : '';
      this.subscribeNewsletter(email);
      this.goResult();
    }

    // Inscrit le profil à la newsletter (consentement RGPD coché) via l'API client Klaviyo.
    // Liste "Newsletter" = WQ5N57 ; clé publique Klaviyo = RkCp6D (single opt-in -> abonné immédiat).
    subscribeNewsletter(email) {
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RkCp6D', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Diagnostic capillaire',
                profile: { data: { type: 'profile', attributes: {
                  email: email,
                  first_name: this.profile.firstname || ''
                } } }
              },
              relationships: { list: { data: { type: 'list', id: 'WQ5N57' } } }
            }
          })
        }).catch(function () {});
      } catch (e) {}
    }

    goResult() {
      this.items = this.computeRoutine();
      this.renderResult();
      var idx = this.screens.findIndex(function (s) { return s.dataset.screen === 'result'; });
      this.screens.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      this.nav.hidden = true; this.progress.hidden = true; this.scrollTop();
      this.pushKlaviyo();
      this.pushLead();
    }

    // Lien Klaviyo <- Shopify : identifie le profil + pousse l'event diagnostic (déclencheur du futur flow)
    pushKlaviyo() {
      try {
        var k = window.klaviyo || window._learnq; if (!k || !this.profile || !this.profile.email) return;
        var self = this, p = this.profile;
        var idAttrs = { '$email': p.email, '$first_name': p.firstname || '', 'Telephone': p.phone || '' };
        if (p.phoneE164) idAttrs['$phone_number'] = p.phoneE164;
        k.push(['identify', idAttrs]);
        var total = 0;
        var routine = (this.items || []).map(function (it) {
          var src = self.poolCard(it.key), P0 = P[it.key] || {};
          var actifsEl = src && src.querySelector('.diag__prod__actifs');
          var phraseEl = src && src.querySelector('.diag__prod__phrase');
          var prix = src ? (parseInt(src.dataset.price || '0', 10) / 100) : null;
          if (prix) total += prix;
          return {
            nom: P0.name || it.key, role: it.role || '', essentiel: !!it.essential,
            actifs: actifsEl ? actifsEl.textContent.trim() : '',
            desc: phraseEl ? phraseEl.textContent.trim() : '',
            prix: prix, url: P0.url ? ('https://lao-care.com' + P0.url) : '', img: P0.img || ''
          };
        });
        var cartUrl = 'https://lao-care.com/cart/' + (this.items || []).map(function (it) { return (P[it.key] || {}).id + ':1'; }).join(',');
        k.push(['track', 'Diagnostic LAO Complété', {
          Prenom: p.firstname || '', Age: p.age || '', Genre: p.gender || '',
          Telephone: p.phone || '',
          Epaisseur: this.answers.epaisseur || '', Texture: this.answers.texture || '',
          Shampoing: this.shampoo(), RoutineNom: this.routineName(),
          SiliconeDetox: this.needsSilicone(), CodePromo: this.promoCode || '',
          NbProduits: (this.items || []).length, Total: total, RemiseRoutinePct: this.discountFor((this.items || []).length),
          CodeExpiry: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 19),
          CartUrl: cartUrl, Routine: routine, Blocs: this.klavBlocs || []
        }]);
      } catch (e) {}
    }

    // Événement de conversion "Lead" (Ads) à la complétion du diagnostic, juste avant l'écran résultat.
    // Tiré une seule fois, best-effort sur les canaux présents (Meta, Google, TikTok, GTM, Shopify Customer Events).
    pushLead() {
      if (this._leadFired) return; this._leadFired = true;
      try { if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: 'Diagnostic capillaire' }); } catch (e) {}
      try { if (typeof gtag === 'function') gtag('event', 'generate_lead', { event_category: 'diagnostic' }); } catch (e) {}
      try { if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track('SubmitForm', { content_name: 'Diagnostic capillaire' }); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'diagnostic_lead', diagnostic: 'complete' }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('diagnostic_lead', { source: 'Diagnostic capillaire' }); } catch (e) {}
    }

    renderResult() {
      var self = this, name = this.profile.firstname || 'Vous';
      var nm = this.querySelector('[data-diag-name]'); if (nm) nm.textContent = name;
      var top = this.querySelector('[data-diag-reco-top]'), blocks = this.querySelector('[data-diag-blocks]');
      top.innerHTML = ''; blocks.innerHTML = '';
      this.klavBlocs = [];

      // HERO — mini routine builder (cartes riches + récap + code promo)
      this.removed = {};
      this.accessories = {};
      this.renderHero();

      // BLOCS contenu (metaobjects)
      var alim = [], ft = [], tags = { cuir: 'Cuir chevelu', longueur: 'Longueurs', perte: 'Perte de cheveux', coiffant: 'Coiffage' };
      ['cuir', 'longueur', 'perte', 'coiffant'].forEach(function (dim) {
        var v = self.answers[dim]; if (!v) return;
        if (dim === 'perte' && v === 'perte_non') return;
        var t = (self.isThick() && TEXT[v + '_epais']) ? TEXT[v + '_epais'] : TEXT[v]; if (!t) return;
        var html = '<span class="diag__block__tag">' + (tags[dim] || '') + '</span>';
        if (t.title) html += '<h3>' + t.title + '</h3>';
        if (t.problem) html += self.para(self.fill(t.problem));
        if (t.reco) html += '<div class="diag__block__reco">' + self.para(self.fill(t.reco)) + '</div>';
        if (t.tips) html += '<div class="diag__block__tips"><strong>Votre astuce d\'utilisation&nbsp;:</strong> ' + self.para(self.fill(t.tips)) + '</div>';
        var b = document.createElement('div'); b.className = 'diag__block'; b.id = 'diag-blk-' + dim; b.innerHTML = html; blocks.appendChild(b);
        ft.push({ id: b.id, label: tags[dim] || '' });
        self.klavBlocs.push({ sujet: tags[dim] || '', titre: t.title || '', probleme: self.richText(self.fill(t.problem || '')), reco: self.richText(self.fill(t.reco || '')), tips: self.richText(self.fill(t.tips || '')) });
        if (t.alimentation) alim.push(t.alimentation);
      });

      // Étape 0 — Silicone Détox
      if (this.needsSilicone() && TEXT['silicone_detox']) {
        var s = TEXT['silicone_detox'], h = '<span class="diag__block__tag">Étape 0</span>';
        if (s.title) h += '<h3>' + s.title + '</h3>';
        h += self.para(s.problem) + '<div class="diag__block__reco">' + self.para(s.reco) + '</div>' + (s.tips ? '<div class="diag__block__tips"><strong>Utilisation&nbsp;:</strong> ' + self.para(s.tips) + '</div>' : '');
        var be = document.createElement('div'); be.className = 'diag__block diag__block--etape0'; be.id = 'diag-blk-etape0'; be.innerHTML = h; blocks.appendChild(be);
        ft.push({ id: be.id, label: 'Étape 0' });
        self.klavBlocs.push({ sujet: 'Étape 0', titre: s.title || '', probleme: self.richText(s.problem || ''), reco: self.richText(s.reco || ''), tips: self.richText(s.tips || '') });
      }
      // Encadré mousseux
      if (this.isCurly() && this.answers.mousseux === 'mousseux_oui' && TEXT['mousseux']) {
        var mo = TEXT['mousseux'], bm = document.createElement('div'); bm.className = 'diag__block diag__block--mousseux'; bm.id = 'diag-blk-mousseux';
        bm.innerHTML = '<span class="diag__block__tag">Astuce bonus</span><h3>' + (mo.title || '') + '</h3>' + self.para(mo.reco);
        blocks.appendChild(bm);
        ft.push({ id: bm.id, label: 'Astuce' });
      }

      // Fast-track : chips d'accès rapide vers chaque bloc
      var ftEl = this.querySelector('[data-diag-fasttrack]');
      if (ftEl) {
        if (ft.length > 1) {
          ftEl.hidden = false;
          ftEl.innerHTML = '<span class="diag__ft__lbl">Accès rapide</span>' + ft.map(function (f) { return '<a class="diag__ft__chip" href="#' + f.id + '">' + f.label + '</a>'; }).join('');
          ftEl.querySelectorAll('.diag__ft__chip').forEach(function (a) {
            a.addEventListener('click', function (e) {
              e.preventDefault();
              var tgt = document.getElementById(a.getAttribute('href').slice(1));
              if (tgt) { var off = (window.innerWidth <= 749 ? 56 : 70) + 12; window.scrollTo({ top: tgt.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' }); }
            });
          });
        } else { ftEl.hidden = true; ftEl.innerHTML = ''; }
      }

      // Toggle alimentation
      var alimEl = this.querySelector('[data-diag-alim]'), alimBody = this.querySelector('[data-diag-alim-body]');
      if (alim.length && alimEl) { alimEl.hidden = false; alimBody.innerHTML = self.para(alim.join('\n\n')); }
      else if (alimEl) alimEl.hidden = true;
    }

    handleOf(key) { var u = (P[key] && P[key].url) || ''; return u.split('/').pop(); }
    poolCard(key) { var pool = this.querySelector('[data-diag-pool]'); return pool ? pool.querySelector('.diag__prod[data-handle="' + this.handleOf(key) + '"]') : null; }
    activeItems() { var self = this; return (this.items || []).filter(function (it) { return !self.removed[it.key]; }); }
    money(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) + ' €'; }

    renderHero() {
      var self = this, top = this.querySelector('[data-diag-reco-top]');
      top.innerHTML = '';
      var wrap = document.createElement('div'); wrap.className = 'diag__rb';
      var main = document.createElement('div'); main.className = 'diag__rb-main';
      main.innerHTML = '<p class="diag__eyebrow">Votre routine sur-mesure LAO Care</p>'
        + '<div class="diag__cta-row diag__cta-row--top"><button type="button" class="diag__btn diag__btn--primary diag__btn--lg" data-diag-add-cart>Ajouter ma routine au panier</button></div>';
      var list = document.createElement('div'); list.className = 'diag__rb-items';
      this.items.forEach(function (it) {
        var src = self.poolCard(it.key), card;
        if (src) { card = src.cloneNode(true); card.hidden = false; var r = card.querySelector('[data-role]'); if (r) r.textContent = it.role || ''; }
        else { card = document.createElement('div'); card.className = 'diag__prod'; card.innerHTML = '<div class="diag__prod__body"><h4 class="diag__prod__title">' + ((P[it.key] || {}).name || it.key) + '</h4></div>'; }
        card.dataset.key = it.key;
        if (it.essential) {
          var pr = card.querySelector('.diag__prod__price');
          var badge = document.createElement('span'); badge.className = 'diag__prod__essential'; badge.textContent = 'Essentiel';
          if (pr && pr.parentNode) pr.parentNode.insertBefore(badge, pr.nextSibling);
          else { var bd = card.querySelector('.diag__prod__body'); if (bd) bd.appendChild(badge); }
        }
        var rm = card.querySelector('[data-diag-remove]');
        if (rm) rm.addEventListener('click', function () { self.toggleRemove(it.key, card); });
        list.appendChild(card);
      });
      // Cross-sell : si moins de 3 produits, suggérer un complément pertinent
      if (this.items.length < 3) {
        var have = {}; this.items.forEach(function (it) { have[it.key] = 1; });
        var pri = ['apres', 'masque', 'creme', 'gelee', 'silicone'], sugg = null;
        for (var i = 0; i < pri.length; i++) { if (!have[pri[i]] && self.poolCard(pri[i])) { sugg = pri[i]; break; } }
        if (sugg) {
          var sc = self.poolCard(sugg).cloneNode(true); sc.hidden = false; sc.classList.add('diag__prod--suggest');
          var r2 = sc.querySelector('[data-role]'); if (r2) r2.textContent = 'Complétez votre routine';
          var ab = sc.querySelector('[data-diag-remove]');
          if (ab) { ab.textContent = '+ Ajouter'; ab.className = 'diag__prod__add'; ab.addEventListener('click', function () { self.items.push({ key: sugg, role: 'Complément' }); self.renderHero(); }); }
          list.appendChild(sc);
        }
      }
      main.appendChild(list);
      // Accessoires — version mobile (au-dessus du CTA)
      var accM = document.createElement('div'); accM.className = 'diag__acc-mobile';
      accM.innerHTML = '<p class="diag__acc-mobile__t">Pensez à votre accessoire</p>';
      this.fillAccessories(accM);
      main.appendChild(accM);
      main.insertAdjacentHTML('beforeend',
        '<div class="diag__rb-gauge"><div class="diag__rb-bar"><span data-bar></span></div><div class="diag__rb-tiers" data-tiers></div></div>' +
        '<div data-promo></div>' +
        '<div class="diag__cta-row"><button type="button" class="diag__btn diag__btn--primary diag__btn--lg" data-diag-add-cart>Ajouter ma routine au panier</button><p class="diag__cta-price" data-cta-price></p></div>');
      wrap.appendChild(main);
      // Accessoires — version desktop (colonne droite)
      var aside = document.createElement('aside'); aside.className = 'diag__rb-acc';
      aside.innerHTML = '<p class="diag__rb-acc__t">Pensez à votre accessoire</p>';
      this.fillAccessories(aside);
      wrap.appendChild(aside);
      top.appendChild(wrap);
      this.updateRecap();
    }

    fillAccessories(container) {
      var self = this, pool = this.querySelector('[data-diag-acc]'); if (!pool) return;
      var row = document.createElement('div'); row.className = 'diag__acc__row';
      Array.prototype.forEach.call(pool.children, function (src) {
        var c = src.cloneNode(true); c.hidden = false;
        self.syncAccItem(c);
        row.appendChild(c);
      });
      container.appendChild(row);
    }

    accVid(item) {
      var sel = item && item.querySelector('[data-diag-acc-variant]');
      return (sel && sel.value) || (item && item.getAttribute('data-vid'));
    }

    syncAccItem(item) {
      if (!item) return;
      var ab = item.querySelector('[data-diag-acc-add]'); if (!ab) return;
      var added = this.accessories && this.accessories[this.accVid(item)];
      ab.textContent = added ? 'Ajouté ✓' : '+ Ajouter';
      ab.disabled = !!added;
    }

    async addAccessory(btn) {
      var self = this, item = btn.closest('.diag__acc__item');
      var sel = item && item.querySelector('[data-diag-acc-variant]');
      var vid = (sel && sel.value) || btn.dataset.vid; if (!vid) return;
      var handle = btn.dataset.handle || (item && item.getAttribute('data-handle'));
      btn.disabled = true;
      try {
        var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) });
        if (!r.ok) throw new Error('acc');
        self.accessories = self.accessories || {};
        var accP = parseInt(btn.dataset.price || (item && item.dataset.price) || '0', 10);
        if (sel) { var opt = sel.options[sel.selectedIndex]; if (opt && opt.dataset.price) { var sp = parseInt(opt.dataset.price, 10); if (!isNaN(sp)) accP = sp; } }
        if ((!accP || isNaN(accP)) && item) {
          var pe = item.querySelector('.diag__acc__price');
          if (pe) { var pv = parseFloat(pe.textContent.replace(/[^0-9.,]/g, '').replace(',', '.')); if (!isNaN(pv)) accP = Math.round(pv * 100); }
        }
        var accNm = btn.dataset.name || (item && item.dataset.name) || '';
        if (!accNm && item) { var ne = item.querySelector('.diag__acc__name'); if (ne) accNm = ne.textContent.trim(); }
        if (sel) { var ot = sel.options[sel.selectedIndex]; if (ot && ot.value) accNm += ' - ' + ot.textContent.trim(); }
        self.accessories[vid] = { price: isNaN(accP) ? 0 : accP, name: accNm };
        var clones = handle ? self.querySelectorAll('.diag__acc__item[data-handle="' + handle + '"]') : (item ? [item] : []);
        Array.prototype.forEach.call(clones, function (it) {
          var s = it.querySelector('[data-diag-acc-variant]'); if (s) s.value = vid;
          self.syncAccItem(it);
        });
        self.updateRecap();
      } catch (e) { btn.disabled = false; alert('Accessoire momentanément indisponible.'); }
    }

    toggleRemove(key, card) {
      this.removed[key] = !this.removed[key];
      card.classList.toggle('is-removed', this.removed[key]);
      var b = card.querySelector('[data-diag-remove]'); if (b) b.textContent = this.removed[key] ? 'Remettre' : 'Retirer';
      this.updateRecap();
    }

    updateRecap() {
      var self = this, act = this.activeItems(), n = act.length, total = 0, comp = 0;
      act.forEach(function (it) { var src = self.poolCard(it.key); if (src) { total += parseInt(src.dataset.price || '0', 10); comp += parseInt(src.dataset.compare || src.dataset.price || '0', 10); } });
      var bar = this.querySelector('[data-bar]'); if (bar) bar.style.width = Math.min(100, n / 5 * 100) + '%';
      var tl = this.querySelector('[data-tiers]'); if (tl) tl.innerHTML = [3, 4, 5].map(function (t) { return '<span class="diag__rb-tier' + (n >= t ? ' is-on' : '') + '">' + t + ' = -' + self.discountFor(t) + '%</span>'; }).join('');
      var eco = comp > total ? Math.round((comp - total) / comp * 100) : 0;
      var disc = this.discountFor(n), net = Math.round(total * (1 - disc / 100));
      var save = Math.max(0, comp - net);
      var accTotal = 0, accCount = 0, accs = this.accessories || {};
      Object.keys(accs).forEach(function (k) { accTotal += accs[k].price || 0; accCount++; });
      var ctaP = this.querySelector('[data-cta-price]');
      if (ctaP) {
        var base = (save > 0 ? '<s>' + this.money(comp) + '</s> <strong>' + this.money(net) + '</strong>' : '<strong>' + this.money(total) + '</strong>');
        var saveLine = save > 0 ? '<span class="diag__cta-save">Économisez ' + this.money(save) + '</span>' : '';
        var accLine = accCount > 0 ? '<span class="diag__cta-acc">+ ' + this.money(accTotal) + ' <span class="diag__cta-acc__lbl">(' + (accCount > 1 ? 'accessoires' : 'accessoire') + ')</span></span>' : '';
        var franco = parseInt(this.dataset.franco || '0', 10), shipLine = '';
        if (franco > 0 && n > 0) {
          var reste = franco - (net + accTotal);
          shipLine = reste <= 0
            ? '<span class="diag__cta-ship">Livraison en point relais offerte</span>'
            : '<span class="diag__cta-ship">Plus que ' + this.money(reste) + ' pour la livraison en point relais offerte</span>';
        }
        ctaP.innerHTML = base + saveLine + accLine + shipLine;
      }
      var promoEl = this.querySelector('[data-promo]');
      if (promoEl) {
        promoEl.innerHTML = (n > 0 && n < 3) ? '<p class="diag__rb-disc">Ajoutez ' + (3 - n) + ' produit(s) pour activer votre remise routine.</p>' : '';
      }
    }

    async addToCart() {
      var btns = this.querySelectorAll('[data-diag-add-cart]');
      btns.forEach(function (b) { b.disabled = true; b.dataset.old = b.textContent; b.textContent = 'Ajout en cours…'; });
      var src = this.activeItems(); if (!src.length) src = this.items || this.computeRoutine();
      var items = src.map(function (it) { return { id: P[it.key].id, quantity: 1 }; });
      try {
        var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!r.ok) throw new Error('cart');
        // Marque la commande comme issue du diagnostic capillaire (attribut de panier => note de commande)
        try {
          await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Source': 'Diagnostic capillaire', 'Diagnostic capillaire': 'Oui' } }) });
        } catch (e) {}
        // Ouvre le panier (tiroir) pour voir le total et la livraison, au lieu d'envoyer directement au paiement
        var drawer = document.querySelector('cart-drawer');
        if (window.LaoPanier && window.LaoPanier.ouvrir) {
          window.LaoPanier.ouvrir();
          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { source: 'diagnostic' } }));
        } else if (drawer) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          setTimeout(function () { drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); }, 350);
        }
        if (window.LaoPanier || drawer) {
          btns.forEach(function (b) { b.textContent = 'Routine ajoutée ✓'; });
          setTimeout(function () { btns.forEach(function (b) { b.disabled = false; b.textContent = b.dataset.old || 'Ajouter ma routine au panier'; }); }, 3000);
        } else {
          window.location.href = '/cart';
        }
      } catch (e) {
        btns.forEach(function (b) { b.disabled = false; b.textContent = b.dataset.old || 'Ajouter ma routine au panier'; });
        alert('Un produit est momentanément indisponible. Réessayez ou retirez-le de la routine.');
      }
    }

    scrollTop() {
      try {
        var wrap = this.querySelector('.diag__wrap') || this;
        var off = (window.innerWidth <= 749 ? 56 : 70);
        var y = wrap.getBoundingClientRect().top + window.pageYOffset - off;
        if (Math.abs(window.pageYOffset - y) > 2) window.scrollTo({ top: y, behavior: 'auto' });
      } catch (e) {}
    }
  }

  if (!customElements.get('diagnostic-builder')) customElements.define('diagnostic-builder', DiagnosticBuilder);
})();
